/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'delete': {
    width: 16,
    height: 16,
    viewBox: '0 0 100 100',
    data: '<path pid="0" d="M38.77 39.949h6v33.039h-6zM55.23 39.949h6v33.039h-6z"/><path pid="1" d="M56.762 8.2H43.239a8 8 0 0 0-8 8v4.929H15.911a3 3 0 0 0 0 6h5.328l2.91 52.379v.004c.383 6.894 6.094 12.289 13 12.277h25.73c6.91.012 12.617-5.383 13-12.277l2.91-52.38h5.329l.004-.003a3 3 0 0 0 0-6h-19.36v-4.93a8 8 0 0 0-8-8zm-15.512 8c0-1.106.895-2 2-2h13.512a2.003 2.003 0 0 1 2 2v4.929H41.239zm31.512 10.93l-2.89 52.061a7.002 7.002 0 0 1-7 6.61h-25.75a7.002 7.002 0 0 1-7-6.61L27.238 27.13z"/>'
  }
})
